module["exports"] = [
  "București",
  "Cluj-Napoca",
  "Timișoara",
  "Iași",
  "Constanța",
  "Craiova",
  "Brașov",
  "Galați",
  "Ploiești",
  "Oradea",
  "Brăila",
  "Arad",
  "Pitești",
  "Sibiu",
  "Bacău",
  "Târgu Mureș",
  "Baia Mare",
  "Buzău",
  "Botoșani",
  "Satu Mare",
  "Râmnicu Vâlcea",
  "Drobeta-Turnu Severin",
  "Suceava",
  "Piatra Neamț",
  "Târgu Jiu",
  "Târgoviște",
  "Focșani",
  "Bistrița",
  "Reșița",
  "Tulcea",
  "Călărași",
  "Alba Iulia",
  "Giurgiu",
  "Deva",
  "Hunedoara",
  "Zalău",
  "Sfântu Gheorghe",
  "Bârlad",
  "Vaslui",
  "1387",
  "Slobozia",
  "Turda",
  "Mediaș",
  "Voluntari",
  "Lugoj",
  "Medgidia",
  "Onești",
  "Miercurea Ciuc",
  "Sighetu Marmației",
  "Petroșani",
  "Mangalia",
  "Tecuci",
  "Râmnicu Sărat",
  "Pașcani",
  "Dej",
  "Reghin",
  "Năvodari",
  "Odorheiu Secuiesc",
  "Câmpina",
  "Mioveni",
  "Câmpulung",
  "Caracal",
  "Săcele",
  "Făgăraș",
  "Fetești",
  "Sighișoara",
  "Borșa",
  "Roșiorii de Vede",
  "Curtea de Argeș",
  "Sebeș",
  "Huși",
  "Fălticeni",
  "Pantelimon",
  "Oltenița",
  "Turnu Măgurele",
  "Caransebeș",
  "Dorohoi",
  "Rădăuți",
  "Zărnești",
  "Lupeni",
  "Aiud",
  "Petrila",
  "Buftea",
  "Moinești",
  "Târnăveni",
  "Câmpia Turzii",
  "Popești-Leordeni",
  "Gherla",
  "Carei",
  "Cugir",
  "Blaj",
  "Codlea",
  "Comănești",
  "Târgu Neamț",
  "Motru",
  "Târgu Secuiesc",
  "Moreni",
  "Gheorgheni",
  "Băicoi",
  "Orăștie",
  "Salonta",
  "Balș",
  "Drăgășani",
  "Băilești",
  "Calafat",
  "Filiași",
  "Cernavodă",
  "Câmpulung Moldovenesc",
  "Breaza",
  "Marghita",
  "Baia Sprie",
  "Luduș",
  "Corabia",
  "Adjud",
  "Vișeu de Sus",
  "Bragadiru",
  "Bocșa",
  "Râșnov",
  "Urziceni",
  "Pucioasa",
  "Vatra Dornei",
  "Cisnădie",
  "Mizil",
  "Toplița",
  "Chitila",
  "Șimleu Silvaniei",
  "Buhuși",
  "Vicovu de Sus",
  "Zimnicea",
  "Găești",
  "Gura Humorului",
  "Otopeni",
  "Ocna Mureș",
  "Avrig",
  "Simeria",
  "Pecica",
  "Dăbuleni",
  "Bolintin-Vale",
  "Rovinari",
  "Comarnic",
  "Vălenii de Munte",
  "Sânnicolau Mare",
  "Dărmănești",
  "Moldova Nouă",
  "Târgu Lăpuș",
  "Săcueni",
  "Videle",
  "Scornicești",
  "Boldești-Scăeni",
  "Sântana",
  "Târgu Ocna",
  "Măgurele",
  "Călan",
  "Beclean",
  "Țăndărei",
  "Sovata",
  "Oravița",
  "Jibou",
  "Urlați",
  "Hârlău",
  "Beiuș",
  "Ianca",
  "Jimbolia",
  "Topoloveni",
  "Drăgănești-Olt",
  "Sinaia",
  "Nehoiu",
  "Covasna",
  "Negrești-Oaș",
  "Strehaia",
  "Dolhasca",
  "Orșova",
  "Valea lui Mihai",
  "Murfatlar",
  "Aleșd",
  "Darabani",
  "Cristuru Secuiesc",
  "Flămânzi",
  "Mărășești",
  "Sângeorz-Băi",
  "Liteni",
  "Târgu Frumos",
  "Titu",
  "Hațeg",
  "Oțelu Roșu",
  "Ineu",
  "Năsăud",
  "Huedin",
  "Odobești",
  "Hârșova",
  "Bumbești-Jiu",
  "Seini",
  "Salcea",
  "Podu Iloaiei",
  "Eforie",
  "Uricani",
  "Baraolt",
  "Bușteni",
  "Tășnad",
  "Iernut",
  "Agnita",
  "Babadag",
  "Băbeni",
  "Târgu Cărbunești",
  "Negrești",
  "Recaș",
  "Siret",
  "Măcin",
  "Chișineu-Criș",
  "Plopeni",
  "Mihăilești",
  "Șomcuta Mare",
  "Fieni",
  "Întorsura Buzăului",
  "Călimănești",
  "Panciu",
  "Nădlac",
  "Zlatna",
  "Pătârlagele",
  "Cehu Silvaniei",
  "Amara",
  "Budești",
  "Anina",
  "Dumbrăveni",
  "Câmpeni",
  "Pogoanele",
  "Tăuții-Măgherăuș",
  "Tismana",
  "Curtici",
  "Techirghiol",
  "Sărmașu",
  "Vlăhița",
  "Cajvana",
  "Săveni",
  "Segarcea",
  "Pâncota",
  "Răcari",
  "Făget",
  "Tălmaciu",
  "Buziaș",
  "Fundulea",
  "Murgeni",
  "Teiuș",
  "Însurăței",
  "Bicaz",
  "Târgu Bujor",
  "Ștei",
  "Lehliu Gară",
  "Horezu",
  "Deta",
  "Slănic",
  "Piatra-Olt",
  "Ardud",
  "Bălan",
  "Sebiș",
  "Brezoi",
  "Potcoava",
  "Gătaia",
  "Novaci",
  "Miercurea Nirajului",
  "Baia de Aramă",
  "Copșa Mică",
  "Vânju Mare",
  "Sângeorgiu de Pădure",
  "Geoagiu",
  "Săliște",
  "Ciacova",
  "Rupea",
  "Milișăuți",
  "Isaccea",
  "Abrud",
  "Fierbinți-Târg",
  "Cavnic",
  "Săliștea de Sus",
  "Băile Herculane",
  "Bălcești",
  "Berbești",
  "Ghimbav",
  "Predeal",
  "Țicleni",
  "Azuga",
  "Aninoasa",
  "Bucecea",
  "Băile Olănești",
  "Slănic Moldova",
  "Miercurea Sibiului",
  "Sulina",
  "Baia de Arieș",
  "Făurei",
  "Ocna Sibiului",
  "Bechet",
  "Căzănești",
  "Ocnele Mari",
  "Berești",
  "Borsec",
  "Băile Govora",
  "Vașcău",
  "Nucet",
  "Solca",
  "Băile Tușnad"
];